import coverImage from 'img/editor/doc-edit.png';
import { xray } from 'lib/xray';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

const radarName = 'mob_doc_edit_banner';

export const MobileDocEditBanner: FC = () => {
    const [isOpen, setIsOpen] = useState(true);

    const onClose = useCallback(() => {
        xray.send(`${radarName}_close`);
        setIsOpen(false);
    }, [setIsOpen]);

    useEffect(() => xray.send(`${radarName}_show`), []);

    return (
        <MobileDialog
            id="mobile-doc-edit-banner"
            title={
                <>
                    Редактируйте в веб-
                    <br />
                    версии Облака
                </>
            }
            text={<>Чтобы редактировать документ, откройте его в&nbsp;веб-версии Облака</>}
            actions={[
                {
                    id: 'ok',
                    text: 'Хорошо',
                    primary: true,
                    onClick: onClose,
                },
            ]}
            icon={<img src={coverImage} style={{ width: 320, height: 160, objectFit: 'cover' }} />}
            mod="mobileV3"
            topmost
            closable
            disableScrolling={false}
            open={isOpen}
            onClose={onClose}
        />
    );
};
